import { CategoryType } from "../../types/category";

interface CategoryFilterProps {
  categories: CategoryType[];
  activeCategory: string;
  onSelect: (cat: string) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  activeCategory,
  onSelect,
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onSelect(cat.id)}
          className={`px-4 py-2 rounded-full text-sm font-medium transition capitalize ${activeCategory === cat.id
              ? "bg-blue-600 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
        >
          {cat.name}
        </button>
      ))}

    </div>
  );
};

export default CategoryFilter;